/* eslint-disable camelcase */
export const errors = {
    required: "Required",
    must_be_less_than: "Must be {{ characters }} characters or less",
    problem_with_our_servers: "There was a problem with our servers. Please try again later.",
    problem_with_our_servers_code: "There was a problem with our servers. The error code is {{ code }}.",
    problem_with_data_submitted: "There was a problem with the data that was submitted to the server",
    connecting_with_our_servers: "There was a problem connecting to our servers. Please try again later.",
    timeout_connecting_servers: "Your request timed out. Please try again.",
    internet_connection_issue: "There is a problem with the connection to the server. Please check your internet connection",
    copy_code: "Copy Code",
    polygon_edit_error: "Polygons must have at least 3 nodes",
    linestring_edit_error: "Lines must have at least 2 nodes",
    unknown_edit_error: "An unknown error occured",
    billing_error: "There was a problem with the billing for your project",
    service_unavailable: "This service is currently unavailable, please contact a project administrator",
    three_nested: "You cannot create a folder more than 3 levels deep",
    error: "Error",
    invalidLink: "Invalid link",
    error_boundaries: {
        title_large: "Oops! Something went wrong.",
        title_small: "Something went wrong!",
        error_message: "Something's gone wrong and our team has been alerted. If the problem persists, contact support on ",
        error_code: "Error code: {{ code }}",
        contact: "Contact us",
        refresh: "Refresh",
        reload: "Reload",
        webgl_error_title: "WebGL Error Detected",
        webgl_error_message: "Your browser or device does not support WebGL, which is required to view this plan.",
        webgl_support_message: "You may be able to find guidance on enabling WebGL here: ",
        webgl_error_contact: "If the problem persists, contact support at ",
        version_error_title: "A new version of Iventis is available",
        version_error_message: "Please refresh your browser to load the latest version of Iventis.",
        connection_error_title: "Connection Error",
        connection_error_message: "There was a problem with your connection. Please check your internet connection and try again.",
    },
    digital_twin: {
        capacity: "Insufficient server capacity for the digital twin. Please try again later, or contact {{ supportEmail }} for more information",
        occupied: "The digital twin is currently occupied. Please try again later.",
        afk: "You have been disconnected from the digital twin due to inactivity.",
        connection_failed: "Failed to connect to the digital twin service. Please try again later.",
        generic: "There was a problem with the digital twin service. Please try again later.",
    },
    custom_network_error: {
        create: {
            title: "Failed to create {{ entity }}",
            message: "Creating {{ entity }}, was not saved",
        },
        update: {
            title: "Failed to update {{ entity }}",
            message: "Your changes to the {{ entity }}, were not saved",
        },
        import_error: {
            title: "Failed to import {{ entity }}",
            message: "Your {{ entity }}, were not imported",
        },
        export_error: {
            title: "Failed to export {{ entity }}",
            message: "Your {{ entity }}, were not exported",
        },
        delete_error: {
            title: "Failed to delete {{ entity }}",
            message: "Your {{ entity }}, was not deleted",
        },
        generic: {
            title: "Failed to {{ action }}",
            message: "Your request to '{{ action }}' was not successful",
        },
    },
} as const;
